import { useEffect, useState } from 'react';
import { UserAuth } from '../../context/AuthContext';
import useSSE from '../../utils/useSSE'
import strings from "../../locales/ro.json"

import "./Handrules.css"
import HeaderElement from "../../components/HeaderElement/HeaderElement";
import HandrulesBox from "../../components/Handrules/HandrulesBox/HandrulesBox"
import HandrulesButtons from "../../components/Handrules/HandrulesButtons/HandrulesButtons"
import requestHandler from '../../utils/requestHandler';
import pencil from "../../assets/icons/pencil.svg";
import x from "../../assets/icons/x.svg";
import TehnicLock from '../../components/Handrules/TehnicLock/TehnicLock';

const Handrules = () => {
    const { user } = UserAuth();
	const [isAdmin, setIsAdmin] = useState(false);
	const [editMode, setEditMode] = useState(false);
	useEffect(() => {
		if(user.isAdmin) console.log(user.accessToken);
		if(!user.accessToken) return;
		requestHandler(`users/${user.email.split('@')[0]}`, "GET", `Bearer ${user.accessToken}`)
		.then((response) => {
			if(response.groups.includes("Admins")) {
				setIsAdmin(true);
			}
		})
	}, [user.accessToken,user.email]);
	useEffect(() => {
		if(isAdmin) {
			requestHandler("handrules/69", "PUT", `Bearer ${user.accessToken}`);
		}
	}, [isAdmin, user.accessToken])
    const { data, error, setToken } = useSSE('handrules/69', true);
	const [tehnic, setTehnic] = useState(false);
	useEffect(() => {
		setToken(user.accessToken);
	}, [user.accessToken])
	
	useEffect(() => {
		if(!data) return;
		setTehnic(data.q[0]?.type === "T");
	}, [data])

	return(
		<div>
			{ data ? (<div className="handrulesContainer">
				<HeaderElement headerText={strings.handrules.title}/>
				<HandrulesBox main={data.current} q={data.q} editMode={editMode} displayName={user.displayName} token={`Bearer ${user.accessToken}`}/>
				<HandrulesButtons token={user.accessToken} editMode={editMode} lock={data.lock}/>

				<TehnicLock isAdmin={isAdmin && editMode} active={tehnic} token={user.accessToken}/>
			</div>) : (<div>{error}</div>)}
			{isAdmin ? (<div onClick={() => {
				setEditMode(!editMode)
			}} 
			className="adminButton">{!editMode ? (<img className="pencil" src={pencil} alt='editMode'/>) : "X"}</div>) : undefined}
			{editMode ? (<div className="editMode"></div>) : undefined}
		</div>
	)
}

export default Handrules;